export enum CodeMode {
  review = 'review',
  writing = 'writing',
}
